/**
 * The site's type system (Font Lab pick, 2026-09-29):
 *
 *   --font-display  Geist   — headings and display numerals (weight 800, tracking -0.018em: see globals.css)
 *   --font-text     Figtree — body copy and UI
 *
 * Both are SIL OFL 1.1 (Google Fonts), latin subsets, variable weight, self-hosted from /public/fonts and declared in
 * globals.css with their real names. Preloaded in layout.tsx. The two resolved stacks are exported for the places a CSS
 * variable can't reach: SVG presentation attributes (var() is not allowed there) and inline styles on third-party chart
 * components. Everywhere else use the Tailwind classes `font-sans` / `font-display`.
 */
export const FONT_TEXT = "'Figtree', 'Figtree Fallback', ui-sans-serif, system-ui, sans-serif";
export const FONT_DISPLAY = "'Geist', 'Geist Fallback', ui-sans-serif, system-ui, sans-serif";
